export class Bracelet {
    id: number;
    bracelet_code: string;
    seller_dni: string;
    seller_name: string;
    seller_short_id: string;
    fuel_station_id: number;
}